import { api } from "../api";
import { VehicleLiveType } from "../../../types/types";

const findVehicleLive = (token: string, vehicleId: number, customerId: number, departmentId: number, ignoreDepartments: boolean = false, signal?: AbortSignal) => {
    return api.get<VehicleLiveType>(`/vehicles/${vehicleId}/live`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { customerId, departmentId, ignoreDepartments },
        signal,
        timeout: 10000,
    });
};

export default findVehicleLive;
